/** @jsxImportSource @emotion/react */
import React from 'react'
import { Tooltip } from 'antd'
import { LinkOutlined, PictureOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { iconButtonsContainerStyle, iconButtonStyle } from './styles'

interface FeedPostModalIconButtonsProps {
  showImage: boolean
  showLink: boolean
  onToggle: (section: 'image' | 'link' | 'sendVia') => void
  sendViaSelected?: boolean
  onSendViaClick?: () => void
}

/**
 * Icon buttons component for the feed post modal - handles image, link, and send via toggles
 */
const FeedPostModalIconButtons: React.FC<FeedPostModalIconButtonsProps> = ({
  showImage,
  showLink,
  onToggle,
}) => {
  'use memo'

  return (
    <div css={iconButtonsContainerStyle}>
      <Tooltip title='Add Image' zIndex={100000}>
        <div onClick={() => onToggle('image')} css={iconButtonStyle}>
          <PictureOutlined
            style={{
              color: showImage ? colors.SECONDARY_100 : colors.PRIMARY,
              fontSize: 24,
            }}
          />
        </div>
      </Tooltip>
      <Tooltip title='Add Link' zIndex={100000}>
        <div onClick={() => onToggle('link')} css={iconButtonStyle}>
          <LinkOutlined
            style={{
              color: showLink ? colors.SECONDARY_100 : colors.PRIMARY,
              fontSize: 24,
            }}
          />
        </div>
      </Tooltip>
    </div>
  )
}

export default FeedPostModalIconButtons
